// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"SurveyDetails_textBlock__3eTjA","pdfMode":"SurveyDetails_pdfMode__HrCn9"};